import React, { useContext, useRef, useEffect, useState } from 'react';
import { FaBars, FaBell, FaCog, FaSignOutAlt, FaChevronDown, FaChevronUp, FaUser, FaLock, FaBullhorn } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { logout as apiLogout, getAdminById } from '../middleware/backend_hepler';
import { AuthContext } from '../Context/AuthContext';
import logo from "../assets/right.png";


const Topbar = ({ onToggle, isSidebarExpanded }) => {
  const navigate = useNavigate();
  const { logout, adminRole, adminId } = useContext(AuthContext); 
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      if (adminId) {
        try {
          const data = await getAdminById(adminId);
          console.log(data);
          
          setAdminData(data);
        } catch (error) {
          console.error('Failed to fetch admin data:', error);
        }
      }
    };

    fetchAdminData();
  }, [adminId]);


  const showConfirmation = (message) => {
    return new Promise((resolve) => {
      const alertOverlay = document.createElement('div');
      const alertElement = document.createElement('div');
  
      alertOverlay.className = 'alert-overlay-logout';
  
      alertElement.className = 'alert-logout show confirmation-alert';
      alertElement.innerHTML = `
        <img src="${logo}" alt="Logo" class="logo" />
        <p>${message}</p>
        <div class="alert-buttons-logout">
          <button class="alert-no">No</button>
          <button class="alert-yes">Yes</button>
        </div>
      `;
  
      document.body.appendChild(alertOverlay);
      document.body.appendChild(alertElement);
  
      alertOverlay.style.display = 'block';
      alertElement.style.display = 'flex';
  
      alertElement.querySelector('.alert-yes').addEventListener('click', () => {
        resolve(true);
        closeAlert();
      });
  
      alertElement.querySelector('.alert-no').addEventListener('click', () => {
        resolve(false);
        closeAlert();
      });
  
      const closeAlert = () => {
        alertElement.classList.remove('show');
        alertOverlay.classList.remove('show');
        setTimeout(() => {
          alertElement.remove();
          alertOverlay.remove();
        }, 300); 
      };
    });
  };
  
  const handleLogout = async () => {
    const confirmation = await showConfirmation('Are you sure you want to Logout from RIGHT LENDER ?');
    
    if (confirmation) {
      try {
        await apiLogout();
        // await showAlert('Logout successful!');
        logout();
        navigate('/logout-alert'); 
      } catch (error) {
        console.error('Logout error:', error.response ? error.response.data : error.message);
      }
    }
  };
  
  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handlePasswordClick = () => {
    navigate('/changepassword');
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handleMenuItemClick = (action) => {
    setDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getInitials = (name) => {
    if (!name) return '';
    const names = name.split(' ');
    const initials = names.map(n => n.charAt(0).toUpperCase()).join('');
    return initials;
  };

  const showAlert = (message) => {
    return new Promise((resolve) => {
      const alertElement = document.createElement('div');
      alertElement.className = 'alert show';
      alertElement.innerHTML = `
        ${message}
        <span class="close-btn">&times;</span>
      `;
      document.body.appendChild(alertElement);
  
      const closeBtn = alertElement.querySelector('.close-btn');
      const closeAlert = () => {
        alertElement.classList.remove('show');
        setTimeout(() => {
          alertElement.remove();
          resolve(); 
        }, 100); 
      };
  
      closeBtn.addEventListener('click', closeAlert);

      setTimeout(closeAlert, 100);
    });
  };
  

  return (
    <div className={`topbar ${isSidebarExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="topbar-left">
        <div className="menu-icon" onClick={onToggle}>
          <FaBars />
        </div>
      </div>
      <div className="topbar-right">
        {/* <div className="user-info">
          {adminData?.photo ? (
            <img
              src={decodeURIComponent(adminData.photo)}
              alt="User Avatar"
              className="user-avatar"
            />
          ) : (
            <div className="user-avatar default-avatar">
              {getInitials(adminData?.name)}
            </div>
          )}
        </div> */}
        <div className="name-dropdown" ref={dropdownRef}>
          <div className="name-dropdown-header" onClick={handleDropdownToggle}>
            <p>{adminRole}</p>
                   <FaCog className="topbar-icon spin" title="Settings" />
          </div>
          {isDropdownOpen && (
            <div className="dropdown-menu-profile">
              <div className="dropdown-menu-item-profile" onClick={() => handleProfileClick('myProfile')}>
                <FaUser className="menu-icon-profile user" />
                <p>My Profile</p>
              </div>
              {adminRole !== "customer"&&(
                <div className="dropdown-menu-item-profile" onClick={() => handlePasswordClick('ChangePassword')}>
                  <FaLock className="menu-icon-profile lock" />
                  <p>Change Password</p>
                </div>
              )}
              <div className="dropdown-menu-item-profile" onClick={handleLogout}>
                <FaSignOutAlt className="menu-icon-profile signout" />
                <p>Logout</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
